<template>
    <div class="bar">
        <div class="top">
            <div class="left" v-if="!!$slots.breadcrumbs">
                <slot name="breadcrumbs"></slot>
            </div>
        </div>

        <div class="bottom">
            <div class="left" v-if="!!title">
                <h1 class="page-title">{{ title }}</h1>
            </div>

            <div class="right" v-if="!!$slots.default"><slot></slot></div>
        </div>

        <div class="links">
            <a
                v-for="(item, index) in links"
                :key="index"
                :class="{
                    link: true,
                    'headline-font': true,
                    active: !!item.active
                }"
                :href="item.link"
                >{{ item.title }}</a
            >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
            required: false
        },
        links: {
            type: Array,
            default: null,
            required: false
        }
    }
};
</script>
